module.exports = __webpack_public_path__ + "img/EIUOV-二维码.ebf14e5b.png";